(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.ageGate = {
        attach: function (context, settings) {
            const LANG_SELECTOR_KEY = 'language_selector_dismissed';
            const htmlElement = document.documentElement;

            once('age-gate', '.content.age-gate', context).forEach(function (ageGateElement) {
                const contentWrapper = ageGateElement.querySelector('.age-gate__content');

                const getLang = function () {
                    return (htmlElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
                };
                const getAgeGateKey = function () {
                    return 'age_gate_dismissed_' + getLang();
                };

                const showAgeGate = function () {
                    if (localStorage.getItem(getAgeGateKey()) === 'true') {
                        return;
                    }
                    setTimeout(function () {
                        ageGateElement.classList.add('age-gate--visible');
                    }, 500);
                };
                const hideAgeGate = function () {
                    localStorage.setItem(getAgeGateKey(), 'true');
                    ageGateElement.classList.remove('age-gate--visible');
                };

                const langSwitchLink = contentWrapper.querySelector('a[href*="/en"], a[href*="/fr"]');
                if (langSwitchLink) {
                    langSwitchLink.addEventListener('click', function () {
                        localStorage.removeItem('age_gate_dismissed_en');
                        localStorage.removeItem('age_gate_dismissed_fr');
                    });
                }

                const form = contentWrapper.querySelector('form');
                if (form) {
                    const provinceSelect = form.querySelector('select[name="province"]') || form.querySelector('select');
                    const dobInput = form.querySelector('input[name="dob"]');
                    const dob19Input = form.querySelector('input[name="dob_19"]');
                    const dateInputs = [dobInput, dob19Input].filter(Boolean);
                    const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
                    // Province legal age mapping (option values from webform, EN keys for FR form too)
                    const provinceAges = {
                        'Alberta': 18,
                        'British Columbia': 19,
                        'Manitoba': 18,
                        'New Brunswick': 19,
                        'Newfoundland and Labrador': 19,
                        'Northwest Territories': 19,
                        'Nova Scotia': 19,
                        'Nunavut': 19,
                        'Ontario': 18,
                        'Prince Edward Island': 18,
                        'Quebec': 18,
                        'Saskatchewan': 18,
                        'Yukon': 19
                    };

                    function getRequiredAge() {
                        return provinceAges[provinceSelect.value] || 18;
                    }

                    function getActiveDateInput() {
                        if (!provinceSelect || !provinceSelect.value) {
                            return null;
                        }
                        return getRequiredAge() >= 19 ? dob19Input : dobInput;
                    }

                    function setDateInputsDisabled(disabled) {
                        dateInputs.forEach(function (input) {
                            input.disabled = disabled;
                            if (disabled) {
                                input.value = '';
                                input.removeAttribute('max');
                            }
                        });
                    }

                    if (dateInputs.length) {
                        setDateInputsDisabled(true);
                    }
                    if (submitButton) {
                        submitButton.disabled = true;
                    }

                    function updateButtonState() {
                        if (!provinceSelect || !submitButton) {
                            return;
                        }
                        const activeDateInput = getActiveDateInput();
                        const hasDate = activeDateInput && activeDateInput.value;
                        submitButton.disabled = !(provinceSelect.value && hasDate);
                    }

                    function setDateInputMax() {
                        const activeDateInput = getActiveDateInput();
                        if (!activeDateInput) {
                            return;
                        }
                        const age = getRequiredAge();
                        const maxYear = new Date().getFullYear() - age;
                        activeDateInput.max = maxYear + '-12-31';
                    }

                    function onProvinceChange() {
                        if (provinceSelect.value) {
                            setDateInputsDisabled(true);
                            const activeDateInput = getActiveDateInput();
                            if (activeDateInput) {
                                activeDateInput.disabled = false;
                                setDateInputMax();
                            }
                        } else {
                            setDateInputsDisabled(true);
                        }
                        updateButtonState();
                    }

                    if (provinceSelect && dateInputs.length) {
                        provinceSelect.addEventListener('change', onProvinceChange);
                        dateInputs.forEach(function (input) {
                            input.addEventListener('input', updateButtonState);
                            input.addEventListener('change', updateButtonState);
                        });
                    }
                    updateButtonState();
                    form.addEventListener('submit', function (e) {
                        sessionStorage.setItem(getAgeGateKey(), 'true');
                        hideAgeGate();
                    });
                }

                document.addEventListener('languageSelected', function () {
                    showAgeGate();
                });


                if (localStorage.getItem(LANG_SELECTOR_KEY) === 'true' && localStorage.getItem(getAgeGateKey()) !== 'true') {
                    setTimeout(function () {
                        ageGateElement.classList.add('age-gate--visible');
                    }, 1500);
                }
            });
        }
    };

})(Drupal, once);
